import { styled } from '@linaria/react';
import { Radio as MantineRadio, RadioProps } from '@mantine/core';
import { forwardRef } from 'react';
import { secondaryBase } from '../../styles/design-tokens';
import { ReactNode } from 'react';

interface Props extends RadioProps {
  label?: ReactNode;
  error?: ReactNode;
  description?: ReactNode;
}

export const Radio = forwardRef<HTMLInputElement, Props>(
  ({ color = secondaryBase, label, error, description, ...props }, ref) => {
    return (
      <StyledRadio
        variant="outline"
        ref={ref}
        color={color}
        label={label}
        error={error}
        description={description}
        {...props}
      />
    );
  },
);

const StyledRadio = styled(MantineRadio)`
  .mantine-Radio-radio {
    cursor: pointer;
    
    &:checked {
      background-color: var(--base-white);
      border-color: var(--secondary-base);
      border: 2px solid var(--secondary-base);
    }
    
    &:hover {
      border-color: var(--secondary-light);
    }
    
    &:disabled {
      cursor: not-allowed;
      background-color: var(--sky-lighter);
      border-color: var(--sky-base);
      
      &:hover {
        border-color: var(--sky-base);
      }
    }
  }
  
  /*
   * Mantine 9.2 centers the indicator SVG via "translate: -50% -50%" + "top/left: 50%",
   * independent of "transform" (which it uses for the scale-in animation). Setting our
   * own "transform: translate(-50%, -50%)" here would double-translate the icon off-center,
   * producing a crescent-shaped dot. Color and size come from Mantine's --radio-icon-color
   * and --radio-icon-size CSS vars driven by the "color" and "size" props.
   */
  .mantine-Radio-label {
    padding-left: 8px;
  }
`;
